"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAddressesOperation = void 0;
exports.getAddressesOperation = {
    method: 'GET',
    name: 'getAddresses',
    id: 'getAddresses',
    groupName: 'evm',
    urlPathPattern: '/profile/{profileId}/addresses',
    urlPathParamNames: ['profileId'],
    getRequestUrlParams: getRequestUrlParams,
    serializeRequest: serializeRequest,
    deserializeRequest: deserializeRequest,
    deserializeResponse: deserializeResponse,
};
// Methods
function getRequestUrlParams(request) {
    return {
        profileId: request.profileId,
    };
}
function deserializeResponse(jsonResponse) {
    return jsonResponse;
}
function serializeRequest(request) {
    return request;
}
function deserializeRequest(jsonRequest) {
    return jsonRequest;
}
//# sourceMappingURL=getAddressesOperation.js.map